export default function fSortArrayDate(
    arr: Array<any>,
    code: string,
    asc = false
) {
    return arr.sort((a, b) => {
        let nameA = a[code];
        let nameB = b[code];
        if (Date.parse(nameA) && Date.parse(nameB)) {
            nameA = new Date(nameA).getTime();
            nameB = new Date(nameB).getTime();
        }
        if (asc) {
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
        } else {
            if (nameA > nameB) {
                return -1;
            }
            if (nameA < nameB) {
                return 1;
            }
        }
        return 0;
    });
}
